import { PropsCheckBox, PropsCheckBoxAgree } from './PropsCheckBox';
import classNames from 'classnames';

import styles from './CheckBox.module.scss';

export const CheckBox = ({ children, reg, className, ...props }: PropsCheckBox): JSX.Element => {
  return (
    <div className={classNames(styles.CheckBox, props.disabled && styles.Disable, className)}>
      <input type="checkbox" {...reg} {...props} />
      <span className={styles.checked}></span>
      <label htmlFor={props?.id}>{children}</label>
    </div>
  );
};

export const CheckBoxAgree = ({ id, reg, className }: PropsCheckBoxAgree): JSX.Element => {
  return (
    <CheckBox
      className={classNames(styles.CheckBoxAgree, className)}
      defaultChecked={true}
      id={id}
      reg={reg}
      data-testid="checkbox-personal-data"
    >
      <div className={styles.Text}>Даю согласие на обработку</div>
      <a target="_blank" href="/static-page/soglasie/" rel="noreferrer">
        персональных данных
      </a>
    </CheckBox>
  );
};

export const CheckBoxReceiveNotifications = ({ id, reg, className }: PropsCheckBoxAgree): JSX.Element => {
  return (
    <CheckBox
      className={classNames(styles.CheckBoxAgree, className)}
      defaultChecked={false}
      id={id}
      reg={reg}
      data-testid="checkbox-receive-notifications"
    >
      <div className={styles.Text}>Хочу получать</div>
      <a target="_blank" href="/pages/view/soglasierekl/" rel="noreferrer">
        информацию о товарах и акциях
      </a>
    </CheckBox>
  );
};

export const CheckBoxAgreeLk = ({ id, reg, defaultChecked, onChange, className }: PropsCheckBoxAgree): JSX.Element => {
  return (
    <CheckBox
      className={classNames(styles.CheckBoxAgree, className)}
      onChange={onChange}
      defaultChecked={defaultChecked}
      id={id}
      reg={reg}
      data-testid="checkbox-agree-lk"
    >
      <div className={styles.Text}>Даю согласие на обработку</div>
      <a target="_blank" href="/pages/soglashenie-na-obrabotku-personalnyih-dannyih/" rel="noreferrer">
        персональных данных
      </a>
    </CheckBox>
  );
};
